<template>
  <div class="faqList">
    <div class="faqList__content">
      <h2 class="faqList__heading">Vanliga frågor om e-faktura:</h2>
      <ul class="faqList__list">
        <li class="faqList__item" v-for="(item, index) in items" :key="index">
          <FaqItem
            :heading="item.heading"
            :description="item.description"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FaqItem from './FaqItem'

export default {
  name: 'Faq',
  components: {
    FaqItem
  },
  data () {
    return {
      isOpen: false,
      items: [
        {
          heading: 'Hur fungerar e-faktura?',
          description: '<p>E-faktura är en elektronisk faktura som skickas direkt till din internetbank. Det enda du behöver göra är att logga in på din bank och godkänna fakturan så betalas den. Uppgifter som OCR-nummer, belopp och betalningsdag är redan ifyllda när e-fakturan kommer till dig.</p>'
        },
        {
          heading: 'Vilka är fördelarna?',
          description: '<p>E-faktura är ett bra val eftersom det minskar användningen av papper och postala utskick.</p>'
        },
        {
          heading: 'När får jag första e-fakturan?',
          description: '<p>Det kan ta upp emot en vecka för oss att ändra så att du får e-faktura. Skulle du hinna få en pappersfaktura efter att du anmält e-faktura så ska den betalas som vanligt.</p>'
        },
        {
          heading: 'Kan jag koppla e-faktura till min respektives bank istället för min egen? ',
          description: '<p>Nej, e-fakturan kan bara kopplas till den som står som kund hos Vattenfall.</p>'
        },
        {
          heading: 'Kan jag avsluta e-faktura?',
          description: '<p>Ja, du avslutar tjänsten genom att logga in på din internetbank och göra en avanmälan gällande e-fakturan hos Vattenfall Kundservice AB.</p>'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/components/Faq.vue